import type { PropType } from 'vue'

export const progressProps = {
	// 类型：normal或loading
	type: {
		type: String as PropType<'normal' | 'loading' | 'circle'>,
		default: 'normal'
	},
	// 进度条百分比，0~100的数字
	percentage: {
		type: [Number, String],
		default: 0,
		required: true
	},
	// 内部文字
	innerText: {
		type: String,
		default: ''
	},
	// 外部文字
	outerText: {
		type: String,
		default: ''
	},
	// 标题
	title: {
		type: String,
		default: undefined
	},
	// 内容
	content: {
		type: String,
		default: ''
	},
	// 进度位置：outer(在外)、inner(在内)、none(不显示进度)
	textPosition: {
		type: String as PropType<'outer' | 'inner' | 'none'>,
		default: 'inner'
	},
	// 显示值的宽度设置
	textWidth: {
		type: [Number, String],
		default: 'auto'
	},
	// 文本大小
	textSize: {
		type: [Number, String],
		default: 1
	},
	// 颜色
	color: {
		type: String,
		default: 'primary'
	},
	// 宽度
	width: {
		type: [Number, String],
		default: 25
	},
	// 进度条大小
	barSize: {
		type: [Number, String],
		default: 1
	}
}

export type ProgressProps = typeof progressProps
